'use client'

import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { TodayTomorrowNextdays } from '@/types/typo3/sections/spotsanity-weather'
import { Container, Overline } from '@/ui/components'
import IconComponent from '@/ui/Sections/SpotSanityReports/Components/Icon'
import { memo } from 'react'
import SectionHeaderContent from '../SectionHeaderContent/SectionHeaderContent'
interface Props extends React.HTMLAttributes<HTMLDivElement> {
  data: TodayTomorrowNextdays
  selectedDate: string
}

// TODO: Remove this component?

const CardWeather = ({ data, selectedDate, ...props }: Props) => {
  //stores
  const D = useStoreI18n.use.dictionary()

  return (
    <div className="" {...props}>
      <SectionHeaderContent as="h2" titleLayout="2">
        {data?.dateText}
      </SectionHeaderContent>
      <Container className="relative grid grid-cols-2 xl:grid-cols-3">
        <div className="col-span-2 flex flex-col">
          <p>
            {data?.author}
            <br />
            {data?.updateDate}
          </p>
        </div>
        <div className="gap-y-xs pt-md col-span-2 flex flex-col">
          <div className="gap-xs grid md:grid-cols-3">
            {data?.days?.map((item, index: number) => (
              <div
                key={`${selectedDate}_${item.dateText}_${index.toString()}`}
                className={cn(
                  'md:p-lg p-md gap-y-2xs flex h-full items-center justify-between bg-neutral-200 md:flex-col md:justify-center'
                )}
              >
                <div>
                  {item.labelText && (
                    <p className="textstyle-md-bold text-neutral-600">
                      {item.labelText}
                    </p>
                  )}
                  {item.dateText && (
                    <p className="text-neutral-400">{item.dateText}</p>
                  )}
                  {item.min && item.max && (
                    <p className="hide-desktop text-neutral-400">
                      min. {item.min} / max. {item.max}
                    </p>
                  )}
                </div>
                <div>
                  <IconComponent
                    className="h-36 w-36 max-md:h-20 max-md:w-20"
                    icon={`weather_big_${item?.icon}`}
                  />
                </div>
                {item.min && item.max && (
                  <p className="hide-mobile hide-tablet text-neutral-400">
                    min. {item.min} / max. {item.max}
                  </p>
                )}
              </div>
            ))}
          </div>
          <div className="p-md bg-neutral-200">
            {data?.prognose &&
              data?.prognose?.map((item, index: number) => (
                <div
                  key={`${selectedDate}_${data.date}_prognose_${index.toString()}`}
                  className="py-md gap-y-2xs flex flex-col"
                >
                  <Overline>{item.title}</Overline>
                  <p className="textstyle-md-regular text-neutral-600">
                    {item.text}
                  </p>
                </div>
              ))}
            {data?.info?.isInfo && (
              <div className="py-md gap-y-2xs flex flex-col">
                <Overline>{D['fe.weather.currentForecast']}</Overline>
                <div className="gap-xs gap-x-2xl grid md:grid-cols-2">
                  <div className="flex justify-between">
                    <p>
                      <b className="wrap-break-word">
                        {D['fe.weather.temperatures']}
                      </b>
                    </p>
                    <p>
                      min. {data.info.min} / max. {data.info.max}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p>
                      <b className="wrap-break-word">
                        {D['fe.weather.probabilityOfPrecipitationPercentage']}
                      </b>
                    </p>
                    <p>{data.info.probabilityAtNight}</p>
                  </div>
                  <div className="flex justify-between">
                    <p>
                      <b className="wrap-break-word">
                        {D['fe.weather.sunshine']}
                      </b>
                    </p>
                    <p>{data.info.sunshine}</p>
                  </div>
                  <div className="flex justify-between">
                    <p>
                      <b className="wrap-break-word">
                        {D['fe.weather.sunriseSunset']}
                      </b>
                    </p>
                    <p>{data.info.sunriseAndSunset}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  )
}

export default memo(CardWeather)
